import * as type from '../types';

export const setGDDKFilterStation = station => ({
    type: type.SET_GDDK_FILTER_STATION,
    payload: station
})

export const setGDDKFilterResourceType = resourceType => ({
    type: type.SET_GDDK_FILTER_RESOURCE_TYPE,
    payload: resourceType
})

export const setGDDKFilterGDDKPeriod = payload => ({
    type: type.SET_GDDK_FILTER_GDDK_PERIOD,
    payload
})

export const getActiveGDDKListRequest = reqParams => ({
    type: type.GET_ACTIVE_GDDK_LIST_REQUEST,
    payload: reqParams
})

export const getActiveGDDKListSucceeded = data => ({
    type: type.GET_ACTIVE_GDDK_LIST_SUCCEEDED,
    payload: data
})

export const getActiveGDDKListFailed = () => ({
    type: type.GET_ACTIVE_GDDK_LIST_FAILED
})

export const setHistoryGDDKFilterResourceType = resourceType => ({
    type: type.SET_HISTORY_GDDK_FILTER_RESOURCE_TYPE,
    payload: resourceType
})

export const setHistoryGDDKFilterGDDKPeriod = payload => ({
    type: type.SET_HISTORY_GDDK_FILTER_GDDK_PERIOD,
    payload
})

export const getGDDKHistoryListRequest = reqParams => ({
    type: type.GET_GDDK_HISTORY_LIST_REQUEST,
    payload: reqParams
})

export const getGDDKHistoryListSucceeded = data => ({
    type: type.GET_GDDK_HISTORY_LIST_SUCCEEDED,
    payload: data
})

export const getGDDKHistoryListFailed = () => ({
    type: type.GET_GDDK_HISTORY_LIST_FAILED
})

export const setGDDKFilterConsumptionPeriod = payload => ({
    type: type.SET_GDDK_FILTER_CONSUMPTION_PERIOD,
    payload
})

export const getGDDKConsumptionListRequest = reqParams => ({
    type: type.GET_GDDK_CONSUMPTION_LIST_REQUEST,
    payload: reqParams
})

export const getGDDKConsumptionListSucceeded = data => ({
    type: type.GET_GDDK_CONSUMPTION_LIST_SUCCEEDED,
    payload: data
})

export const getGDDKConsumptionListFailed = () => ({
    type: type.GET_GDDK_CONSUMPTION_LIST_FAILED
})